module.exports = __webpack_public_path__ + "img/4.3dd0d32f.svg";